export type IncentivesMarketContractTemplateVariable = {
  token: string;
  labelKey: string;
};

export const INCENTIVES_MARKET_CONTRACT_TEMPLATE_VARIABLES: IncentivesMarketContractTemplateVariable[] =
  [
    { token: '{MERCADO_NOMBRE_COMPRADOR}', labelKey: 'IncentivesMarketContractVarBuyerName' },
    { token: '{MERCADO_NOMBRE_VENDEDOR}', labelKey: 'IncentivesMarketContractVarSellerName' },
    { token: '{MERCADO_DNI_COMPRADOR}', labelKey: 'IncentivesMarketContractVarBuyerId' },
    { token: '{MERCADO_DNI_VENDEDOR}', labelKey: 'IncentivesMarketContractVarSellerId' },
    {
      token: '{MERCADO_DOMICILIO_COMPRADOR}',
      labelKey: 'IncentivesMarketContractVarBuyerAddress',
    },
    {
      token: '{MERCADO_DOMICILIO_VENDEDOR}',
      labelKey: 'IncentivesMarketContractVarSellerAddress',
    },
    { token: '{MERCADO_IBAN_VENDEDOR}', labelKey: 'IncentivesMarketContractVarSellerIban' },
    {
      token: '{MERCADO_TITULAR_CUENTA_VENDEDOR}',
      labelKey: 'IncentivesMarketContractVarSellerAccountHolder',
    },
    { token: '{MERCADO_NUM_UNIDADES}', labelKey: 'IncentivesMarketContractVarShareCount' },
    { token: '{MERCADO_CLASE_UNIDADES}', labelKey: 'IncentivesMarketContractVarShareClass' },
    { token: '{MERCADO_PRECIO_UNIDAD}', labelKey: 'IncentivesMarketContractVarPricePerShare' },
    { token: '{MERCADO_PRECIO_TOTAL}', labelKey: 'IncentivesMarketContractVarTotalPrice' },
    { token: '{MERCADO_FECHA}', labelKey: 'IncentivesMarketContractVarDate' },
    { token: '{MERCADO_HORA}', labelKey: 'IncentivesMarketContractVarTime' },
    {
      token: '{MERCADO_REFERENCIA_OPERACION}',
      labelKey: 'IncentivesMarketContractVarOperationRef',
    },
    { token: '{SOCIEDAD_NOMBRE}', labelKey: 'IncentivesMarketContractVarSocietyName' },
    { token: '{SOCIEDAD_CIF}', labelKey: 'IncentivesMarketContractVarSocietyTaxId' },
    { token: '{SOCIEDAD_CIUDAD}', labelKey: 'IncentivesMarketContractVarCity' },
    {
      token: '{MERCADO_FIRMA_COMPRADOR}',
      labelKey: 'IncentivesMarketContractVarBuyerSignature',
    },
    {
      token: '{MERCADO_FIRMA_VENDEDOR}',
      labelKey: 'IncentivesMarketContractVarSellerSignature',
    },
  ];

/** @deprecated Use INCENTIVES_MARKET_CONTRACT_TEMPLATE_VARIABLES */
export const EQUITY_MARKET_CONTRACT_TEMPLATE_VARIABLES =
  INCENTIVES_MARKET_CONTRACT_TEMPLATE_VARIABLES;
